import { QUERY_KEYS } from 'api/query-keys';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { sharedPaymentService } from 'api/services';
import { Site } from 'shared/hooks';

type ForcePayPaymentMutationContext = { site: Site; paymentId: string };
type ForcePayPaymentMutationOptions = UseMutationOptions<
  unknown,
  Error,
  ForcePayPaymentMutationContext
>;
export const useForcePayPayment = (options?: ForcePayPaymentMutationOptions) => {
  const mutationFn = async ({ site, paymentId }: ForcePayPaymentMutationContext) =>
    await sharedPaymentService.forcePayPayment(site, paymentId);
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};

  return useMutation(mutationFn, {
    onSuccess: async (data, variables, context) => {
      queryClient.invalidateQueries(QUERY_KEYS.payments());
      onSuccess && onSuccess(data, variables, context);
    },
    ...restOptions,
  });
};
